export const array = [
  {
    id: "comp1",
    sides: "your info",
  },
  {
    id: "comp2",
    sides: "select plan",
  },
  {
    id: "comp3",
    sides: "Add-ons",
  },
  {
    id: "comp4",
    sides: "Summary",
  },
];
